module.exports = __webpack_public_path__ + "img/ring_skip_0_null_1@2x.86113840.png";